import * as React from 'react'

const SvgAiTagImg = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={16} height={14} viewBox="0 0 16 14" fill="none" {...props}>
    <path
      d="M13.5 0c.25 0 .5.25.5.5V2h1.5c.25 0 .5.25.5.5 0 .281-.25.5-.5.5H14v1.5c0 .281-.25.5-.5.5a.494.494 0 01-.5-.5V3h-1.5a.494.494 0 01-.5-.5c0-.25.219-.5.5-.5H13V.5c0-.25.219-.5.5-.5zm0 9c.25 0 .5.25.5.5V11h1.5c.25 0 .5.25.5.5 0 .281-.25.5-.5.5H14v1.5c0 .281-.25.5-.5.5a.494.494 0 01-.5-.5V12h-1.5a.494.494 0 01-.5-.5c0-.25.219-.5.5-.5H13V9.5c0-.25.219-.5.5-.5zM4.25 5.781L1.687 6.97 4.25 8.156a.976.976 0 01.5.5l1.188 2.563 1.187-2.563a.976.976 0 01.5-.5l2.563-1.187L7.624 5.78a.976.976 0 01-.5-.5L5.937 2.72 4.75 5.28a.976.976 0 01-.5.5zm-.406 3.282L.28 7.437A.516.516 0 010 6.97c0-.188.094-.375.281-.438l3.563-1.656L5.5 1.312A.47.47 0 015.938 1c.187 0 .375.125.468.313l1.625 3.562L11.594 6.5a.547.547 0 01.312.469.47.47 0 01-.312.437L8.03 9.063l-1.625 3.562a.547.547 0 01-.468.313.47.47 0 01-.438-.313L3.844 9.062z"
      fill="#fff"
    />
  </svg>
)

export default SvgAiTagImg
